import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { StandardButton } from '@eika/button';
import { ErrorCard } from '@eika/card';
import { RadioButtons } from '@eika/radio-button';
import { companyForm } from '../../constants';
import { focusOnErrors, requiredFieldWithCustomError } from '../../util/validator';
import OverlayLoader from '../overlay-loader';
const CorporateInformation = _ref => {
  let {
    section,
    doConfirmCorporateInformation,
    goToNext,
    error,
    submitted
  } = _ref;
  const [loading, setLoading] = useState(false);
  const responsibilityTextPart1 = 'Du er ansvarlig for at informasjonen i skjemaet er riktig og at du ikke unnlater viktig informasjon. Opplysningene om selskapet er hentet fra Brønnøysundregistrene.';
  const responsibilityTextPart2 = 'Om du ser at denne informasjonen ikke stemmer må du kontakte banken.';
  useEffect(() => {
    if (submitted && !error) {
      goToNext();
    }
    if (error) {
      setLoading(false);
    }
  }, [error, submitted, goToNext]);
  const getBusinessCodeToSend = values => {
    if (section.businessCodes.length === 1) {
      return section.businessCodes[0].code;
    }
    if (section.businessCodes.length > 1) {
      return values.businessCode;
    }
    return '';
  };
  const submitAnswers = values => {
    setLoading(true);
    const valuesToSend = {
      businessCode: getBusinessCodeToSend(values),
      corporateFormType: section.corporateFormType,
      establishDate: section.establishDate
    };
    doConfirmCorporateInformation(valuesToSend);
  };
  const getRadioOptions = () => {
    return section.businessCodes.map(_ref2 => {
      let {
        code,
        name
      } = _ref2;
      return {
        value: code,
        label: "".concat(code, " - ").concat(name),
        id: code
      };
    });
  };
  const renderIndustryCode = () => {
    if (section.businessCodes.length === 0) {
      return 'Ingen funnet';
    }
    if (section.businessCodes.length === 1) {
      return "".concat(section.businessCodes[0].code, " - ").concat(section.businessCodes[0].name);
    }
    return /*#__PURE__*/React.createElement(Field, {
      name: "businessCode",
      validate: value => requiredFieldWithCustomError(value, 'Velg det alternativet som er mest riktig for ditt firma'),
      render: _ref3 => {
        let {
          input,
          meta
        } = _ref3;
        return /*#__PURE__*/React.createElement("div", {
          className: "radioknobs"
        }, /*#__PURE__*/React.createElement(RadioButtons, {
          options: getRadioOptions(),
          selectedOption: input.value,
          label: "",
          errorMessage: input.value === '' && meta.touched && meta.error ? meta.error : '',
          name: "businessCode",
          id: "businessCode_id",
          onChange: input.onChange
        }));
      }
    });
  };
  const companyFormToDisplay = companyForm[section.corporateFormType] ? "".concat(companyForm[section.corporateFormType], " ").concat(section.corporateFormType) : section.corporateFormType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement(OverlayLoader, null), /*#__PURE__*/React.createElement("div", {
    className: "information-text"
  }, responsibilityTextPart1, /*#__PURE__*/React.createElement("br", null), responsibilityTextPart2), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submitAnswers,
    decorators: [focusOnErrors]
  }, props => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: props.handleSubmit
    }, /*#__PURE__*/React.createElement("h2", {
      className: "form-question"
    }, "Stiftelses\xE5r"), /*#__PURE__*/React.createElement("span", null, section.establishDate && new Date(section.establishDate).getFullYear().toString()), /*#__PURE__*/React.createElement("h2", {
      className: "form-question"
    }, "Selskapsform"), /*#__PURE__*/React.createElement("span", null, companyFormToDisplay), /*#__PURE__*/React.createElement("h2", {
      className: "form-question"
    }, "N\xE6ringskode"), /*#__PURE__*/React.createElement("span", null, renderIndustryCode()), /*#__PURE__*/React.createElement(StandardButton, {
      className: "progress-next-button",
      type: "submit"
    }, "Bekreft"), error && /*#__PURE__*/React.createElement(ErrorCard, {
      title: "Noe gikk galt!",
      description: "Vi kunne ikke lagre svarene dine. Vennligst pr\xF8v igjen senere eller kontakt banken dersom problemene vedvarer"
    }));
  }));
};
export default CorporateInformation;